const statusMap = {
    // 5: "PIXM Verified",
    4: "Google Form Password",
    3: "Reported Phish",
    2: "Unknown",
    1: "Legit",
};

export const getStatusText = (event) => {
    let status = event.isPixmVerified ? "PIXM Verified" : statusMap[event.type] || ((JSON.parse(event.triagedEvent == true)) ? "Verified Phish" : "AI Suspicious");
    return status;
}

